import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { WebTempDependente } from '../../shared/models/webTempDependente.model';
import { WebTempDependenteService } from '../../shared/services/webTempDependente.service';
import { PessoaService } from '../../shared/services/pessoa.service';
import { Finalidade } from '../../shared/models/finalidade.model';
import { FinalidadeService } from '../../shared/services/finalidade.service';
import { WebProcessoControleService } from '../../shared/services/webProcessoControle.service';
import { MatSnackBar } from '@angular/material';
import { LoginStore } from '../../shared/store/login.store';
import { Pessoa } from '../../shared/models/pessoa.model';

@Component({
  selector: 'app-modal-beneficiario-detalhes',
  templateUrl: './modal-beneficiario-detalhes.component.html',
  styleUrls: ['./modal-beneficiario-detalhes.component.scss']
})
export class ModalBeneficiarioDetalhesComponent implements OnInit {

  termoDependente: WebTempDependente = new WebTempDependente();
  listaFinalidade: Finalidade[] = [];
  idPessoaLogada: number;
  loading: boolean = false;

  // Processo é sempre 3 mesmo (confirmado)
  idProcesso = 3;

  constructor(
    public dialogRef: MatDialogRef<ModalBeneficiarioDetalhesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private webTempDependenteService: WebTempDependenteService,
    private pessoaService: PessoaService,
    private finalidadeService: FinalidadeService,
    private webProcessoControleService: WebProcessoControleService,
    private _snackBar: MatSnackBar,
    private loginStore: LoginStore
  ) { }

  ngOnInit(): void {
    this.loading = true;

    this.loginStore.getCurrent().subscribe(ret => {
      this.idPessoaLogada = ret.idPessoa;
    });

    this.loadFinalidades();

    const idDependente = (this.data && this.data.id) ? this.data.id : null;

    if (!idDependente) {
      console.error('ID do dependente não enviado para o modal!');
      return;
    }

    this.webTempDependenteService.getById(idDependente)
      .subscribe(dependente => {

        if (!dependente) {
          console.error("Dependente não encontrado");
          return;
        }

        // garante que o objeto pessoa existe
        if (!dependente.pessoa) {
          dependente.pessoa = new Pessoa();
        }

        // busca os dados completos da pessoa
        this.pessoaService.getById(dependente.idPessoaDep)
          .subscribe(pessoa => {

            dependente.pessoa = pessoa; // agora o objeto completo vem

            this.termoDependente = dependente;
            this.loading = false;


          });

      });
  }

  loadFinalidades() {
    this.finalidadeService.getAll().subscribe(obj => {
      this.listaFinalidade = obj;
    });
  }

  getFinalidade(idFinalidade: number) {
    const finalidade = this.listaFinalidade.find(x => x.idFinalidade == idFinalidade);
    return finalidade ? finalidade.nmFinalidade : "";
  }

processoAcao(idSolicitacao, idProcesso, element, idStatus) {
  this.loading = true;

  idSolicitacao = this.termoDependente.idTemp;

  switch (idStatus) {
    case 1: 
      this.webProcessoControleService
        .DeferirProcesso({
          idProcesso,
          idSolicitacao,
          idContrato: Number(this.termoDependente.idTemp),
          idPessoaLogin: Number(this.idPessoaLogada),
        })
        .subscribe(
          (obj) => {
            this.openSnackBar("Processo deferido com sucesso!", "X");
            this.loading = false;

            if (idProcesso === 10) {
              element.idSTATUS = idStatus;
            } else {
              element.webEsteiraStatus.idStatus = idStatus;
            }
          },
          (error) => {
            this.loading = false;
            this.openSnackBarError(error, "X");
          }
        );

      break;
  }
}

indeferirProcesso() {
  this.loading = true;

  this.webProcessoControleService
    .IndeferirProcesso({
      idProcesso: Number(this.idProcesso),
      idSolicitacao: Number(this.termoDependente.idPessoaDep),
      idContrato: Number(this.termoDependente.idTemp),
      idPessoaLogin: Number(this.idPessoaLogada),
    })
    .subscribe(
      (obj) => {
        this.openSnackBar("O processo foi indeferido com sucesso!", "X");
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        this.openSnackBarError(error, "X");
      }
    );
}

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
      panelClass: ["mat-toolbar", "mat-success"],
    });
  }

  openSnackBarError(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
      panelClass: ["mat-toolbar", "mat-warn"],
    });
  }
  formatarCPF(valor: string | number): string {
    if (!valor) return '';
    const cpf = valor.toString().padStart(11, '0');
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  }

  formatarData(valor: any): string {
    if (!valor) return '';
    const d = new Date(valor);
    if (isNaN(d.getTime())) return valor;
    return d.toLocaleDateString("pt-BR");
  }
  formatarSexo(sexo: any): string {

    if (!sexo) return '';

    const valor = String(sexo).toUpperCase();

    switch (valor) {
      case 'F':
        return 'Feminino';
      case 'M':
        return 'Masculino';
      default:
        return '';
    }
  }
  formatarSimNao(valor: any): string {

    if (!valor) return '';

    const v = String(valor).toUpperCase();

    switch (v) {
      case 'S':
        return 'Sim';
      case 'N':
        return 'Não';
      default:
        return '';
    }
  }


  fechar() {
    this.dialogRef.close();
  }
}
